import { NotificationsActionTypes } from "./notificationActions";
import { NotificationsState } from "./notificationState";

export const notificationsReducer = (
    state: NotificationsState,
    action: NotificationsActionTypes
) => {
    // NOTE: do not use immer's produce in this reducer. can't store components in immer state
    let messages = [...state.messages];

    switch (action.type) {
        case "NOTIFICATION_SHOWN": {
            const existing = state.messages.find(
                m => m.area === action.notification.area
            );
            if (existing) {
                messages = state.messages.filter(
                    m => m.key !== action.notification.key
                );
            }
            messages.push(action.notification);
            return { messages };
        }

        case "NOTIFICATION_CLOSED": {
            const filteredMessages = messages.filter(m => m.key !== action.key);
            return { messages: filteredMessages };
        }

        case "CLOSE_AREA_NOTIFICATION": {
            messages = state.messages.filter(m => m.area !== action.areaName);
            return { messages };
        }

        case "CLOSE_ALL_AREA_NOTIFICATIONS": {
            messages = state.messages.filter(m => m.type !== "area");
            return { messages };
        }

        case "CLOSE_MODAL_NOTIFICATION": {
            messages = state.messages.filter(
                m => m.type !== "modal" && m.title == action.title
            );
            return { messages };
        }

        default: {
            return state;
        }
    }
};
